import {
  clearAccessToken,
  clearRefreshToken,
} from "../../../api/apiClient";
import { authApi } from "../../../api/auth/authApi";
import { appConst } from "../../../AppConst";
import { NotifyHelper } from "../../../helpers/toast";
import { eAuthActionTypeDefine } from "../../action-types/auth/IAuthActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const authAction = {
  ...generateActions(eAuthActionTypeDefine, "AUTH"),
  ...generateActionForKey(
    eAuthActionTypeDefine,
    "AUTH",
    "LOGIN_SUCCESS",
    // Token nằm trong cookie httpOnly do backend đặt — FE không lưu token nữa.
    () => {}
  ),
  ...generateActionForKey(
    eAuthActionTypeDefine,
    "AUTH",
    "LOGOUT_START",
    (payload: any) => {
      // Xóa phiên phía server (cookie sid + Redis); lấy id_token_hint để end-session ở SSO.
      authApi
        .logout()
        .then((res: any) => {
          const idTokenHint = res?.data?.id_token_hint ?? res?.id_token_hint ?? "";
          clearAccessToken();
          clearRefreshToken();
          if (appConst.OIDC_UNIT === "vnpt") {
            const state = sessionStorage.getItem("oauth_state");
            const logoutUrl = new URL(`${appConst.OIDC_LOGOUT}`);
            if (idTokenHint) {
              logoutUrl.searchParams.append("id_token_hint", idTokenHint);
            }
            if (appConst.OIDC_REDIRECT_URI) {
              logoutUrl.searchParams.append(
                "post_logout_redirect_uri",
                appConst.OIDC_REDIRECT_URI
              );
            }
            if (state) {
              logoutUrl.searchParams.append("state", state);
            }
            window.location.href = logoutUrl.toString();
          }
        })
        .catch(() => {
          clearAccessToken();
          clearRefreshToken();
        });
    }
  ),
  ...generateActionForKey(
    eAuthActionTypeDefine,
    "AUTH",
    "LOGIN_VNPT_SUCCESS",
    () => {}
  ),
  ...generateActionForKey(
    eAuthActionTypeDefine,
    "AUTH",
    "CHANGE_PASS_SUCCESS",
    (payload: string) => {
      NotifyHelper.Success(payload);
    }
  ),
  ...generateActionForKey(
    eAuthActionTypeDefine,
    "AUTH",
    "CHANGE_PASS_ERROR",
    (payload: string) => {
      NotifyHelper.Error(payload ?? "Thất bại");
    }
  ),
};
